import type { Exercise } from './types';
import { z } from 'zod';

const API_URL = 'https://oss.exercisedb.dev/api/v1/exercises';

const responseSchema=z.object({success:z.literal(true),data:z.array(z.object({
  exerciseId:z.string().min(1),name:z.string().min(1),gifUrl:z.string().optional(),
  bodyParts:z.array(z.string()).default([]),equipments:z.array(z.string()).default([]),
  targetMuscles:z.array(z.string()).default([]),instructions:z.array(z.string()).default([]),
}))});

export async function searchExerciseDb(query: string, signal?: AbortSignal): Promise<Exercise[]> {
  const value = query.trim();
  if (value.length < 2) return [];
  const controller=new AbortController();
  const abort=()=>controller.abort();
  if(signal?.aborted)controller.abort();
  signal?.addEventListener('abort',abort,{once:true});
  const timeout=setTimeout(abort,12000);
  try {
  const response = await fetch(`${API_URL}?name=${encodeURIComponent(value)}&limit=12`, { signal:controller.signal });
  if (!response.ok) throw new Error(response.status===429?'Batas pencarian tercapai. Coba lagi sebentar.':`Pustaka online belum tersedia (${response.status}).`);
  const parsed=responseSchema.safeParse(await response.json());
  if(!parsed.success)throw new Error('Format pustaka online berubah. Gunakan gerakan lokal atau buat gerakan sendiri.');
  return parsed.data.data.map((item) => ({
    id: `exercisedb-${item.exerciseId}`,
    name: item.name.replace(/\b\w/g, (letter) => letter.toUpperCase()),
    muscleGroup: item.targetMuscles[0] ?? item.bodyParts[0] ?? 'Other',
    equipment: item.equipments[0] ?? 'Other',
    exerciseType: item.bodyParts.some(part=>part.toLowerCase()==='cardio') ? 'cardio' : 'strength',
    isCustom: false,
    instructions: item.instructions.map((instruction) => instruction.replace(/^Step:\d+\s*/i, '')),
    mediaUrl: item.gifUrl && /^https:\/\//i.test(item.gifUrl) ? item.gifUrl : undefined,
    source: 'exercisedb',
    sourceId: item.exerciseId,
  }));
  } finally {clearTimeout(timeout);signal?.removeEventListener('abort',abort);}
}
